type ConfigList = Record<string, string | undefined>;

// CRA inlines process.env.REACT_APP_* at build time only — not read at runtime in the browser bundle.
const BASE_URL = process.env.REACT_APP_BASE_URL ?? 'https://booking.chatbot.mn';
// Deep-link host for the payment-portal admin UI. Operators click through to
// `${PAYMENT_PORTAL_URL}/admin/payments/:intentId` to see the full audit
// timeline — single source of truth lives in the payment system.
const PAYMENT_PORTAL_URL =
  process.env.REACT_APP_PAYMENT_PORTAL_URL ?? 'https://payment.chatbot.mn';

let configList: ConfigList = {
  API_BASE_URL: `${BASE_URL}/api/v1`,
  IMAGE_BASE_URL: `${BASE_URL}/uploads`,
  PAYMENT_PORTAL_URL,
  // Staff kiosk: the public booking page (customers) and the SSO client the
  // tablet signs stylists in with (public, device grant, short TTLs).
  // Not BASE_URL: the admin build points that at the admin host, which would open the admin app.
  PUBLIC_BOOKING_URL: process.env.REACT_APP_PUBLIC_BOOKING_URL ?? 'https://booking.chatbot.mn',
  SSO_ORIGIN: process.env.REACT_APP_SSO_ORIGIN ?? 'https://sso.chatbot.mn',
  KIOSK_CLIENT_ID: process.env.REACT_APP_KIOSK_CLIENT_ID ?? 'booking-kiosk',
};

export interface Config {
  get: (option: string) => string | undefined;
  config: (data: Partial<ConfigList>) => void;
}

const config: Config = {
  get: (option: string) => configList[option],
  config: (data: Partial<ConfigList>) => {
    configList = {
      ...configList,
      ...data
    };
  }
};

export default config;
  